import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { validateForm } from '../utils';

import LabeledTextInput from '../../shared/LabeledTextInput';
import LabeledTextAreaInput from '../../shared/LabeledTextAreaInput';
import LabeledCheckbox from '../../shared/LabeledCheckbox';
import LabeledField from '../../shared/LabeledField';
import JSONEditor from '../../shared/JSONEditor';

const LayoutManagementForm = ({
  displayName = '',
  specificNote = '',
  layout = '',
  visible = true,
  showErrors,
  onFieldChange,
  setFormValidStatus,
}) => {
  const [errors, setError] = useState({});

  useEffect(() => {
    setFormValidStatus(!Object.values(errors).some(Boolean) && validateForm({ layout }));
  }, [errors]);

  const onFieldValidate = (name, error) => {
    setError((prevState) => ({ ...prevState, [name]: error }));
  };

  return (
    <Fragment>
      <Row>
        <Col className="mb-3">
          <LabeledTextInput
            editMode={true}
            label="Display Name *"
            value={displayName}
            onChange={(value) => onFieldChange('displayName', value)}
            minLength={1}
            maxLength={100}
            allowBlank={false}
            error={errors.displayName}
            onValidate={(error) => onFieldValidate('displayName', error)}
            invalid={showErrors && (!displayName || errors.displayName)}
          />
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">
          <LabeledTextAreaInput
            editMode={true}
            label="State-Specific Notices"
            style={{ height: '100px' }}
            value={specificNote}
            onChange={(value) => onFieldChange('specificNote', value)}
            allowBlank={true}
          />
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">
          <LabeledField
            allowBlank={false}
            label="Layout JSON *"
            error={errors.layout}
            invalid={showErrors && (!layout || errors.layout)}
            onValidate={(error) => onFieldValidate('layout', error)}
            onChange={(value) => onFieldChange('layout', value)}
            validator={(value) => {
              try {
                return Array.isArray(JSON.parse(value));
              } catch (error) {
                return false;
              }
            }}
            value={layout}
          >
            <JSONEditor />
          </LabeledField>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <LabeledCheckbox label="Visible" checked={visible} onChange={(value) => onFieldChange('visible', value)} />
      </Row>
    </Fragment>
  );
};

LayoutManagementForm.propTypes = {
  displayName: PropTypes.string,
  specificNote: PropTypes.string,
  layout: PropTypes.string,
  visible: PropTypes.bool,
  showErrors: PropTypes.bool,
  onFieldChange: PropTypes.func,
  setFormValidStatus: PropTypes.func,
};

export default LayoutManagementForm;



// WEBPACK FOOTER //
// src/components/LayoutManagement/LayoutManagementForm/index.jsx